<template lang="pug">
  div
    b-badge(v-if="state === 'entregado'" variant="success") Entregado
    b-badge(v-else-if="state === 'rechazado'" variant="danger") Rechazado
    b-badge(v-else-if="state === 'cancelado'" variant="cancelado") Cancelado
    b-badge(v-else-if="state === 'pendiente'" variant="warning").text-white Pendiente
    b-badge(v-else-if="state === null" variant="light") Por Entregar
    b-badge(v-else-if="state === 'null'" variant="light") Por Entregar
    b-badge(v-else-if="state === ''" variant="light") Por Entregar
    b-badge(v-else variant="light") {{ {state} }}
</template>

<script>
export default {
  props: {
    state: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>

